import {
  Component, EventEmitter, Input, Output, OnInit, ViewChild,
  forwardRef, ContentChild, TemplateRef, ElementRef
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NeqSelectModel } from './neq-select.model';

@Component({
  selector: 'neq-select',
  templateUrl: './neq-select.component.html',
  // tslint:disable-next-line:use-host-property-decorator
  host: { 'class': 'neq-select-autocomplete' },
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NeqSelectComponent),
      multi: true
    }
  ]
})
export class NeqSelectComponent implements OnInit, ControlValueAccessor {

  @Input() dataSource: Function;
  @Input() bindLabel: string;
  @Input() defaultLabel = '';
  @Input() multiple = false;
  @Input() id = '';
  @Input() size = '2';

  @Output() change = new EventEmitter();
  @Output() blur = new EventEmitter();

  @ContentChild(TemplateRef) itemTemplate: TemplateRef<any>;

  @ViewChild('select') select: ElementRef;

  fetched = false;
  loading = false;
  data: NeqSelectModel[] = [];

  // FormControl functions
  private valueAccessorOnChange: (_: any) => {};
  private valueAccessorOnTouched: () => {};

  ngOnInit() {
    this.reset(true);
  }

  onChange(event: any) {
    const value = this.data.find(elt => elt.label === event.target.value);
    if (value?.data) {
      this.change.emit(value.data);
      if (this.valueAccessorOnChange) {
        this.valueAccessorOnChange(value.data);
      }
    }
  }

  onBlur(event: any) {
    this.blur.emit(event);
    if (this.valueAccessorOnTouched) {
      this.valueAccessorOnTouched();
    }
  }

  reset(search?: true) {
    this.fetched = false;
    this.data = [];
    if (search) {
      this.fetch();
    }
  }

  private fetch() {
    this.loading = true;
    if (!this.fetched) {
      Promise.resolve(this.dataSource()).then((result: any) => {
        this.fetched = result && result.length !== 0;
        if (result) {
          this.data = this.data.concat(result);
        }

        this.loading = false;
      });
    }
  }

  writeValue(): void {
    // Required
  }

  registerOnChange(fn: any): void {
    this.valueAccessorOnChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.valueAccessorOnTouched = fn;
  }

}
